import { Box, Container, Stack, Heading, VStack, Text, Show, forwardRef } from '@chakra-ui/react';
import React from 'react';
import { TFunction } from 'i18next';
import DesktopFeatures from './DesktopFeatures';
import MobileFeatures from './MobileFeatures';

interface FeaturesProps {
  t: TFunction;
  ref: React.RefObject<HTMLDivElement>;
}

const Feature: React.VFC<FeaturesProps> = forwardRef(({ t }, ref) => {
  return (
    <Box ref={ref} as="section" pb="16" scrollMargin={['70px', '115px']} scrollSnapAlign="start">
      <Box
        bg="white"
        h="70px"
        mt="-35px"
        sx={{ transformOrigin: '0 0', transform: 'skewY(-1deg)' }}
      />
      <Container maxW="container.xl">
        <Stack align="center" h="100%" justify="center" spacing="8">
          <Heading as="h3" size="2xl">
            {t('what_can_you_do_with_pretia')}
          </Heading>
          <Show below="md">
            <MobileFeatures t={t} />
          </Show>
          <Show above="md">
            <DesktopFeatures t={t} />
          </Show>
        </Stack>
      </Container>
    </Box>
  );
});

export default Feature;
